export function formatCustomerAccountNumber(
  accountNumber: string | null | undefined,
): string {
  if (!accountNumber) {
    return "";
  }
  const number = Number(accountNumber);
  if (Number.isNaN(number)) {
    return accountNumber;
  }

  return new Intl.NumberFormat("FR-fr").format(number);
}
